export const previewPage = async (dispatch, action, page) => {
  try {
    await dispatch(action);

    window.open(`#preview/${page}`, "_blank");
  } catch (e) {}
};
